import React from "react";
import Topheader from "./navbar/Topheader";
import MainNav from "./navbar/MainNav";

const Navbar = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <Topheader />
      <MainNav />
    </div>
  );
};

export default Navbar;
